import { apiRequest, graphqlRequest } from './index'

export const createDeclaration = (declarationInput, declarationFields) => {
  return graphqlRequest(`
    mutation {
      createDeclaration(declarationInput: {
        ${ declarationInput }
      }){
        ${ declarationFields }
      }
    }
  `)
}

export const submitDeclaration = (declarationInput, consent, declarationFields) => {
  return graphqlRequest(`
    mutation {
      submitDeclaration(declarationInput: {
        ${ declarationInput }
      }
      consent : "${ consent }"
      ){
        ${ declarationFields }
      }
    }
  `)
}

export const getDeclarations = (recordId, declarationFields) => {
  return graphqlRequest(`
  {
    getDeclarations(recordId:"${ recordId }") {
      ${ declarationFields }
    }
  }
  `)
}

export const uploadDeclarationAttachment = (_id, recordId, category, file) => {
  const query = `
    mutation ($file: Upload!){
    uploadDeclarationAttachment(attachmentInfo: {
      _id: "${ _id }"
      recordId: "${ recordId }"
      category: "${ category }"
      file: $file
     }
    ){
      attachments {
        category
        key
        name
        size
      }
    }}
  `
  const operations = JSON.stringify({ query, variables: { file: null } })
  const map = {
    '0': ['variables.file']
  }

  const formData = new FormData()
  formData.append('operations', operations)
  formData.append('map', JSON.stringify(map))
  formData.append('0', file)

  return apiRequest('POST', '/beneficiary-api/graphql/v1', formData, { 'content-type': 'multipart/form-data' })
}

export const deleteDeclarationAttachment = (_id, fileKeys) => {

  return graphqlRequest(`
    mutation {
    removeDeclarationAttachment(
        _id: "${ _id }"
        fileKeys: ["${ fileKeys.join('","') }"]
      ) {
        attachments {
          category
          key
          name
          size
        }
      }
    }`)
}
